module.exports = __webpack_public_path__ + "static/binder4-5eb5ffb59bed501f1b582be5584adad1.png";